/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ObjectType({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor"><path d="M6.701 1.48c.578-1 2.02-1 2.598 0l2.152 3.727a1.5 1.5 0 0 1-1.088 2.235l-.212.015v-1.2a.3.3 0 0 0 .26-.45L8.26 2.079a.3.3 0 0 0-.52 0L5.588 5.807a.3.3 0 0 0 .26.45v1.2l-.211-.015a1.5 1.5 0 0 1-1.181-2.046l.093-.19zm3.45 4.777v1.2H5.848v-1.2zM4 9.657a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6m0-1.2a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-2.16 3.233 3.5 3.5 0 0 1-4.573-1.893A3.503 3.503 0 0 1 2.66 8.724c.425-.176.88-.267 1.34-.267M13.996 14.005v1.2H10.5v-1.2zm.3-.3V10.21a.3.3 0 0 0-.3-.3H10.5a.3.3 0 0 0-.3.3v3.496a.3.3 0 0 0 .3.3v1.2l-.153-.008a1.5 1.5 0 0 1-1.34-1.339L9 13.705V10.21a1.5 1.5 0 0 1 1.5-1.5h3.496l.153.008a1.5 1.5 0 0 1 1.347 1.492v3.496l-.008.153a1.5 1.5 0 0 1-1.339 1.34l-.153.007v-1.2a.3.3 0 0 0 .3-.3" /></g></svg>;
}
;